import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import Moment from "react-moment";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
// import ConstantsList from '../../../common/Constants';

//Components
import Layout from "../../../../Layout/Layout";
// import CreatePOMasterModal from "../../../../Components/Modal/supplier_app/PO_Collabration/CreatePOMasterModal";
import Constants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";
import {
  addPoDetailNumber,
  getPurchaseOrder,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
// import configFromEnv from "../../../../services/configuration";
import {
  currencyFormat,
  formatDate,
  formatDateWithAMPM,
} from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import PurchaseOrder3WayMatchModal from "./PurchaseOrder3WayMatchModal";
import {
  addRfxNr,
  quotationListInfo,
} from "../../../../redux/feature/supplier_app/sourcingSlice";
import { useReactToPrint } from "react-to-print";
import PrintPurchaseOrder from "./PrintPurchaseOrder";
// import { MessageCircle } from "lucide-react";
// import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CreatePOV5Modal from "./CreatePOV5Modal";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import SendEmailModalV5 from "../Common/SendEmailModalV5";

// import toast from "react-hot-toast";

const PurchaseOrder = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Material Order");

  let userData = useSelector((state) => state?.user); // User Details from Store
  let purchaseOrderData = useSelector(
    (state) => state?.purchasing?.purchase_order,
  ); // get purchaseOrderData from Store
  // console.log(">>Purchsaer",purchaseOrderData)
  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.pagination,
  ); // User Details from Store

  let config = useSelector((state) => state?.common?.data?.purchaseOrder); // config Details from Store
  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.PO?.module,
  ); // config Details from Store

  const [data, setData] = useState([]);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const [filterShow, setFilterShow] = useState(false);

  // const [chatId, setChatId] = useState(null);

  const [getCreatePO, setCreatePO] = useState();
  const [getDisable, setDisabled] = useState(false);

  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);

  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    if (userData?.data?.roles) {
      const allowedRoles = ["PROC-EXECUTIVE", "SALES-ADMIN", "PROC-MNGR"];

      const isAllowed = userData.data.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );

      setCreatePO(isAllowed);
    }
  }, [userData]);

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const remarkItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(remarkLineItemColInfo);
    setModalTitle("PO Remarks / Version");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  const createRFQ = () => {
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const detailedPage = (poNumber) => {
    // console.log("poNumber", poNumber);
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.CUSTOMER_V5_PURCHASE_ORDER_DETAILS);
  };
  const updatePage = (poNumber, purchasingDocumentType) => {
    // console.log(">>purchasingDocumentType",purchasingDocumentType)
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.CUSTOMER_V5_PURCHASE_ORDER_UPDATE);
  };
  // eslint-disable-next-line
  const detailedPageQuotation = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj));
    // navigate(Constants.SOURCING_QUOTATION_DETAILS);
  };
  // eslint-disable-next-line
  const detailedPageBuyer = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    // navigate(Constants.SOURCING_BUYER_RFQ_DETAILS);
  };
  // const loadInitialPOData = async () => {
  //   let obj = {
  //     module: "PO",
  //     queryName: "getMaterialPO",
  //     page: 1,
  //     per_page: 10,
  //   };

  //   dispatch(getPurchaseOrder(obj));
  //   setData(purchaseOrderData?.data);
  // };
  const loadInitialPOData = () => {
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
    };

    dispatch(getPurchaseOrder(obj));
  };
  useEffect(() => {
    if (purchaseOrderData?.data) {
      setData(purchaseOrderData.data);
    }
  }, [purchaseOrderData]);

  // useEffect(() => {
  //   loadInitialPOData(); // fetch page 1 of users
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  //on page load
  useEffect(() => {
    getMasterData();
    loadInitialPOData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    /*   {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row.vendorCode)}
              title="Chat With the User"
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>

          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",formatDateWithAMPM
    }, */
    {
      name: "Date",
      selector: (row) => formatDateWithAMPM(row?.createdAt) || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium">
            {formatDateWithAMPM(row.createdAt)}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Document/Purchase Type",
      selector: (row) => row.purchasingDocumentCode,
      sortable: true,
      width: "240px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchasingDocumentType} </p>
          <p className="m-0 p-0 pt-1">{row.purchaseType} </p>
        </div>
      ),
    },
    {
      name: "Send Mail",
      cell: (row) => (
        <div>
          <button
            onClick={() => {
              setSelectedRowData(row);
              setShowSupplierInviteModal(true);
            }}
            className="flex items-center justify-center w-10 h-10 rounded-full 
                   bg-[rgb(19_130_246_/_50%)] 
                   hover:bg-[rgb(19_130_246_/_80%)] 
                   text-black-700 hover:text-white
                   shadow-md hover:shadow-lg
                   transition-all duration-300 ease-in-out"
          >
            <i className="bi bi-send text-lg"></i>
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Purchase Type",
    //   selector: (row) => row.purchaseType || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.purchaseType} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Document Nr",
      cell: (row) => (
        <button
          className="btn btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Update",
      cell: (row) => (
        <button
          className="btn btnInfo d-flex  flex-row justify-content-center"
          // disabled={
          //   !(row.statusHeader === "New" || row.statusHeader === "Rejected")
          // }
          disabled={
            !(
              row.statusHeader === "In Release" ||
              row.statusHeader === "PO Revised"
            )
          }
          onClick={() =>
            updatePage(row.purchasingDocumentNr, row?.purchasingDocumentType)
          }
        >
          <i class="bi bi-pencil-square mx-2"></i> Edit
        </button>
      ),
      width: "150px",
    },
    // {
    //   name: "3Way-Match",
    //   cell: (row) => (
    //     <>
    //       {/* <button
    //       className="btnInfo"
    //       onClick={() => po3wayMatch(row.purchasingDocumentNr)}
    //     >
    //       Match
    //     </button> */}
    //       <div
    //         style={{ width: "100%" }}
    //         className="d-flex justify-content-center iconTable"
    //         onClick={() => po3wayMatch(row.purchasingDocumentNr)}
    //       >
    //         <i className="bi bi-mastodon"></i>
    //         {/* <img
    //               src="assets/img/newIcons/workflow.png"
    //               alt="attachments"
    //               style={{ width: "35px" }}
    //               className="mt-1"
    //               onClick={() => showStatusInfo(row.workflowTECHActionLogs)}
    //             /> */}
    //       </div>
    //     </>
    //   ),
    //   width: "120px",
    // },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Invoice Attachement",
      cell: (row) => (
        <div>
          {(row?.grnShippingDocuments && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row?.grnShippingDocuments)}
            />
          )) ||
            "--"}
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "INV Nr/Dt",
      selector: (row) =>
        formatDateWithAMPM(row?.grnPurchasingDocumentDate) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.grnVendorInvoiceNo}</p>
          <p className="p-0 m-0">
            {row?.grnVendorInvoiceDate
              ? formatDate(row.grnVendorInvoiceDate)
              : "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "INV/GST",
      selector: (row) =>
        formatDateWithAMPM(row?.grnVendorTotalInvoiceValue) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">
            {row?.grnVendorTotalInvoiceValue
              ? `AMT ${row?.grnVendorTotalInvoiceValue}`
              : "--"}
          </p>
          <p className="p-0 m-0 fw-medium">
            {row?.grnGstValue ? `GST ${row?.grnGstValue}` : "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Total INV Amt",
      selector: (row) => formatDateWithAMPM(row?.grnTotalInvoiceValue) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">
            {row?.grnTotalInvoiceValue || "--"}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "E-Way Bill",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">
            {row?.grnEwayBillNumber ? <>{row?.grnEwayBillNumber}</> : <>--</>}
          </p>
          <p className="p-0 m-0">
            {row?.grnEwayBillExpiryDate ? (
              <>{formatDate(row?.grnEwayBillExpiryDate)}</>
            ) : (
              <>--</>
            )}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          // onClick={()=>showViewInvoice(row)}
          onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Version",
    //   selector: (row) => row.version || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusHeader} />
        </>
      ),
      selector: (row) => row.statusHeader || "--",
      sortable: true,
      width: "180px",
    },

    // {
    //   name: "PO Value",
    //   cell: (row) => (
    //     <span className="numberFormate m-0 p-0 pt-1 fw-bold">
    //       {currencyFormat(Number(row.purchasingDocumentValue).toFixed(2))}
    //     </span>
    //   ),
    //   selector: (row) => row.purchasingDocumentValue || "--",
    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "PO Value ",
      // cell: (row) => (
      //   <>
      //     <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
      //   </>
      // ),
      cell: (row) => (
        <div>
          <p className="numberFormate  p-0 pt-1 fw-bold m-0">
            {currencyFormat(Number(row.purchasingDocumentValue).toFixed(2))}
            {/* <p className="m-0 p-0">{row.currency} </p> */}
          </p>
          <span className=" p-0 pt-1 fw-bold text-primary">
            {row.currency || "INR"}{" "}
          </span>
        </div>
      ),
      selector: (row) => row.currency || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "110px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "Gate Entry",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          {row.statusHeader === "Rejected" ||
          row.statusHeader === "Cancelled" ? (
            <>--</>
          ) : (
            <>
              <p className="m-0 p-0 pt-1 fw-bold">{row.gateEntrytNr} </p>
              <p className="m-0 p-0">{row.gateEntryDate} </p>
              <span className="fw-bold text-primary">
                {row.gateEntryStatus}
              </span>
            </>
          )}
        </div>
      ),
    },
    {
      name: "Goods Reciept",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div>
          {row.statusHeader === "Rejected" ||
          row.statusHeader === "Cancelled" ? (
            <>--</>
          ) : (
            <>
              <p className="p-0 m-0 fw-bold">
                {(row?.items && row?.items?.[0]?.grn?.grnNumber) || "--"}
              </p>
              <p className="m-0 p-0 pt-1">
                {row?.items && row?.items?.[0]?.grn?.grnNumber ? (
                  <span className="text-success fw-medium">GRN Created</span>
                ) : (
                  <sapn className="text-warning fw-medium">GRN Pending</sapn>
                )}{" "}
              </p>
            </>
          )}
        </div>
      ),
    },
    {
      name: "Quality Check",
      sortable: true,
      width: "220px",
      selector: (row) =>
        row?.qualityCheckDetails?.[0]?.qualityCheckStatus || "QC Pending",

      cell: (row) => {
        const qc = row?.qualityCheckDetails?.[0];

        return (
          <div>
            {row.statusHeader === "Rejected" ||
            row.statusHeader === "Cancelled" ? (
              <> --</>
            ) : (
              <>
                {qc?.qualityCheckNr ? (
                  <>
                    <p className="m-0 p-0 fw-bold text-muted">
                      {qc.qualityCheckNr}
                    </p>
                    <p className="m-0 p-0 text-muted fs-12">
                      {qc.qualityCheckDate}
                    </p>
                    <p className="m-0 p-0 fw-bold text-primary">
                      {qc.qualityCheckStatus}
                    </p>
                  </>
                ) : (
                  <p className="m-0 p-0 fw-bold text-warning">QC Pending</p>
                )}
              </>
            )}
          </div>
        );
      },
    },

    // {
    //   name: "Payment Terms",
    //   cell: (row) => <>{row.paymentTerms}</>,
    //   selector: (row) => row.paymentTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },

    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCodeDesc} </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Version",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row?.version}
          </span>
        </>
      ),
      width: "80px",
    },
    {
      name: "PO Changes Remarks/Version",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => remarkItemShowModal(row.updateRemarks)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {row?.updateRemarks?.length > 0
              ? `${row.updateRemarks.length}/${row?.version}`
              : `0/${row?.version}`}
          </span>
        </>
      ),
      width: "200px",
    },
    {
      name: "Tally Status",
      selector: (row) => row?.tallyStatusIndicator, // Added optional chaining (?)
      cell: (row) => {
        const status = row?.tallyStatusIndicator;

        return (
          <span
            style={{
              fontWeight: "bold",
              color:
                status === "Done"
                  ? "#2563eb" // Blue for Done
                  : status === "Pending"
                    ? "#dc2626" // Red for Pending
                    : "#6b7280", // Gray for missing or unknown status
            }}
          >
            {status || "-"}
          </span>
        );
      },
      wrap: true,
      width: "120px",
    },
    {
      name: "Cancel Remarks",
      cell: (row) => (
        <>
          {row?.cancellationRemark ? (
            <span className="fw-medium text-danger">
              {" "}
              {row.cancellationRemark}{" "}
            </span>
          ) : (
            <span> -- </span>
          )}
        </>
      ),
      width: "150px",
    },

    // {
    //   name: "RFQ",
    //   cell: (row) => (
    //     <button className="btnInfo">{row.rfxCollectiveNr || "--"} </button>
    //   ),
    //   width: "150px",
    // },

    // {
    //   name: "Quotation",
    //   cell: (row) => (
    //     <button className="btnInfo">{row.quotationNumber || "--"}</button>
    //   ),
    //   width: "150px",
    // },

    // {
    //   name: "Delivery Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.deliveredStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Invoice Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.invoicedStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Payment Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.paymentStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "130px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "130px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit ?? row?.unitPrice} </span>,
      width: "130px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.uOM} </span>,
      width: "130px",
    },
    {
      name: "Net Value",
      cell: (row) => <span>{row.netValue} </span>,
      width: "130px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "130px",
    },
  ];

  const remarkLineItemColInfo = [
    {
      name: "Remarks",
      cell: (row) => <span>{row?.remark || ""} </span>,
      width: "180px",
    },
    {
      name: "Version",
      cell: (row) => <span>{row?.version || ""} </span>,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <span>
          {" "}
          <TableStatusField status={row?.status} />
        </span>
      ),
      width: "180px",
    },
  ];
  const getMasterData = async () => {
    setDisabled(true);
    let obj = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    setDisabled(false);
  };

  const handlePageChange = (page) => {
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: page,
      per_page: getNewPerPage,
      vendorCode: userData?.data?.userId,
      role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };

    dispatch(getPurchaseOrder(obj));
    // setData(purchaseOrderData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: page,
      per_page: newPerPage,
      vendorCode: userData?.data?.userId,
      role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getPurchaseOrder(obj));
    // setData(purchaseOrderData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseOrder(obj));
  };

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };
  const [po3wayMatchModalShow, setpo3wayMatchModalShow] = useState(false);
  const [getPoNumber, setPoNumber] = useState(false);

  const po3wanyMatchhideModal = () => {
    setpo3wayMatchModalShow(false);
  };
  // eslint-disable-next-line
  const po3wayMatch = (poNumber) => {
    setpo3wayMatchModalShow(true);
    setPoNumber(poNumber);
  };

  //po print invocie
  const contentRef = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level
  const handlePrint = useReactToPrint({
    contentRef,
    // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  });

  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);

    // Wait for state updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  //chat
  // const toggleChat = (groupId) => {
  //   // Toggle the same PR closes the chat
  //   if (chatId === groupId) {
  //     setChatId(null);
  //   } else {
  //     setChatId(groupId);
  //   }
  // };
  //FITLER
  const filterColumns = [
    {
      id: "vendorName",
      name: "Vendor",
      selectorKey: "vendorName",
    },
    {
      id: "statusHeader",
      name: "Status",
      selectorKey: "statusHeader",
    },
    {
      id: "vendorName",
      name: "Vendor Name",
      selectorKey: "vendorName",
    },
    {
      id: "tallyStatusIndicator",
      name: "Tally Status",
      selectorKey: "tallyStatusIndicator",
      dropDown: true,
      staticOptions: ["Done", "Pending"],
    },
    {
      id: "purchasingDocumentDate",
      name: "Date",
      selectorKey: "purchasingDocumentDate",
      month: true,
    },
    {
      id: "statusHeader",
      name: "Status",
      selectorKey: "statusHeader",
    },
    {
      id: "purchasingDocumentValue",
      name: "PO Value",
      selectorKey: "purchasingDocumentValue",
      numberRange: true,
    },
  ];

  // Helper function to convert string numbers to actual numbers for Number values
  const convertFilterValues = (filterResult) => {
    if (!filterResult || !filterResult.$and) return filterResult;

    const convertedFilter = {
      ...filterResult,
      $and: filterResult.$and.map((filter) => {
        const key = Object.keys(filter)[0];
        const value = filter[key];

        // Check if this is a numeric field
        const numericFields = ["purchasingDocumentValue"]; // Add other numeric fields here

        if (numericFields.includes(key)) {
          // If it's a range filter with $gte and $lte
          if (typeof value === "object" && (value.$gte || value.$lte)) {
            return {
              [key]: {
                ...(value.$gte && { $gte: Number(value.$gte) }),
                ...(value.$lte && { $lte: Number(value.$lte) }),
              },
            };
          }
          // If it's a direct value
          else if (typeof value === "string") {
            return { [key]: Number(value) };
          }
        }

        return filter;
      }),
    };

    return convertedFilter;
  };

  // Update your handleMultiColumnFilter function
  const handleMultiColumnFilter = (filterResult) => {
    // Convert string numbers to actual numbers
    const convertedFilter = convertFilterValues(filterResult);

    // setFilterShow(false);

    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };

    // Add filter if exists
    if (
      convertedFilter &&
      convertedFilter.$and &&
      convertedFilter.$and.length > 0
    ) {
      obj.rowFilter = convertedFilter;
    }

    dispatch(getPurchaseOrder(obj));
  };
  //  Handle filter cancel
  const handleFilterCancel = () => {
    setFilterShow(false);
  };
  //handle view
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle"> Material Purchase Order</h2>
                <p className="subText">
                  Lists of Material Purchase Order and details
                </p>
              </Col>

              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>

              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <MultiColumnFilter
                    columns={filterColumns}
                    data={purchaseOrderData?.data || []} //  Pass current vendor data for dropdown options
                    onFilter={handleMultiColumnFilter}
                    onCancel={handleFilterCancel}
                    output="and" //  Returns { $and: [...] } format
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MT</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material PO List</span>
                      <span className="subHeaderTitle">
                        View of Material PO and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {getCreatePO &&
                        config?.createManualPOBtn &&
                        (userData?.data?.category === "STORE" ? (
                          ""
                        ) : (
                          <Col xs={3} md={3} lg={3} className="">
                            <button
                              className="btn btnTable"
                              onClick={() => createRFQ()}
                              //  disabled={Array.isArray(data) && data.length < 0}
                              disabled={getDisable}
                            >
                              <i className="bi bi-clipboard-check mx-2"></i>
                              Create Purchase Order
                            </button>
                          </Col>
                        ))}

                      {/* {config?.requestSupplierforACK && (
                        <Col xs={3} md={3} lg={3} className="">
                          <button className="btnTable">
                            <i className="bi bi-cart-check"></i> Request PO ACK
                          </button>
                        </Col>
                      )} */}

                      {config?.deletion &&
                        (userData?.data?.category === "STORE" ? (
                          ""
                        ) : (
                          <Col xs={3} md={3} lg={3} className="">
                            <button
                              className="btnTable"
                              onClick={cancelModalShow}
                              disabled={
                                getSelectedRows.length > 0 ? false : true
                              }
                            >
                              <i className="bi bi-x-circle"></i> Cancel
                            </button>
                          </Col>
                        ))}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 5]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <div style={{ display: "none" }}>
          <PrintPurchaseOrder ref={contentRef} data={getLoadingAdvice} />
        </div>
      </Row>

      <CreatePOV5Modal
        show={modalShow}
        onHide={() => hideModal()}
        dropdowndata={getPurchaseDocType}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Purchase Order"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <PurchaseOrder3WayMatchModal
        show={po3wayMatchModalShow}
        onHide={() => po3wanyMatchhideModal()}
        getPoNumber={getPoNumber}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        showDelete={false}
      />
      <SendEmailModalV5
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        // onSubmit={inviteSupplier}
        data={selectedRowData}
      />
      {/* {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )} */}
    </main>
  );
};

export default PurchaseOrder;
